import React, { useState, useEffect, useCallback } from 'react';
import './AppTour.css';

const AppTour = ({ steps, onComplete }) => {
    const [currentStep, setCurrentStep] = useState(0);
    const [spotlight, setSpotlight] = useState({ opacity: 0 });

    const updatePosition = useCallback(() => {
    const step = steps[currentStep];
    const el = document.getElementById(step.targetId);

    if (el) {
        // Scroll slightly above the element so the tooltip doesn't cover it
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });

        // WAIT for scroll and for images/sliders to render height
        setTimeout(() => {
            const rect = el.getBoundingClientRect();
            
            // CHECK: If rect.height is 0, the slider isn't ready. 
            // We wait another 500ms or use a default height.
            const finalHeight = rect.height > 10 ? rect.height : 150;
            const finalTop = rect.height > 10 ? rect.top : 200;

            setSpotlight({
                width: rect.width > 0 ? rect.width + 10 : 60,
                height: finalHeight + 10,
                top: finalTop - 5,
                left: rect.left > 0 ? rect.left - 5 : 20,
                opacity: 1,
                exists: true
            });
        }, 800); // 800ms is safer for mobile rendering
    } else {
        setSpotlight({ opacity: 0, exists: false });
    }
}, [currentStep, steps]);

    useEffect(() => {
        updatePosition();
    }, [updatePosition]);

    const stepData = steps[currentStep];

    return (
        <div className="tour-overlay">
            {spotlight.exists && (
                <div 
                    className="tour-spotlight" 
                    style={{
                        width: `${spotlight.width}px`,
                        height: `${spotlight.height}px`,
                        top: `${spotlight.top}px`,
                        left: `${spotlight.left}px`,
                        opacity: spotlight.opacity,
                        boxShadow: '0 0 0 9999px rgba(0, 0, 0, 0.8)'
                    }}
                />
            )}

            <div className="tour-tooltip" style={{
                // If element is missing or at top, show tooltip at bottom
                bottom: (!spotlight.exists || spotlight.top < 200) ? '10%' : 'auto',
                top: (spotlight.exists && spotlight.top >= 200) ? '10%' : 'auto',
            }}>
                <p className="tour-text">{stepData.content}</p>
                <div className="tour-btns">
                    <button className="tour-skip" onClick={onComplete}>Skip</button>
                    <button className="tour-next" onClick={() => currentStep < steps.length - 1 ? setCurrentStep(s => s + 1) : onComplete()}>
                        {currentStep === steps.length - 1 ? 'Finish' : 'Next'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AppTour;